(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/components/menu.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/components/menu.js');
"use strict";

const usedPitches = [];
const {
  withRouter,
  matchPath
} = svs.app.ReactRouter;
const {
  useEffect
} = React;
const {
  PICK_PATH,
  PLAY_PATH,
  MY_GAMING_PATH
} = svs.tickets.play.utils.constants;
const availableTickets = svs.tickets.data.moduleConfig.availableTickets;
const Menu = _ref => {
  var _currentProduct$ticke, _currentProduct$ticke2, _ticketType;
  let {
    history,
    appTimeline,
    products
  } = _ref;
  const {
    ItemsMenu,
    BallItem
  } = svs.ui.ReactItemsMenu;
  const BubbleUsp = svs.tickets.play.components.BubbleUsp;
  const branding = svs.tickets.data.templateConfig.branding;
  const Brand = svs.ui.ReactBrand;
  const ticketInfoMatch = matchPath(history.location.pathname, {
    path: [PICK_PATH, PLAY_PATH]
  });
  const pickMatch = matchPath(history.location.pathname, {
    path: PICK_PATH
  });
  const myGamingMatch = matchPath(history.location.pathname, {
    path: MY_GAMING_PATH
  });
  let ticketType;
  if (ticketInfoMatch) {
    ticketType = ticketInfoMatch.params.ticketType;
  } else {
    ticketType = svs.tickets.play.utils.utils.getTicketTypeFromWager(myGamingMatch.params.wagerId).ticketType;
  }
  const isTrissBranding = branding === 'triss';
  const menuBg = isTrissBranding ? 'bg-triss' : 'bg-header-skrapspel';
  const currentProduct = _.find(products, product => {
    var _product$alternativeU;
    return product.type.toLowerCase() === ticketType.toLowerCase() || (product === null || product === void 0 || (_product$alternativeU = product.alternativeUrl) === null || _product$alternativeU === void 0 ? void 0 : _product$alternativeU.toLowerCase()) === ticketType.toLowerCase();
  });
  const ticketPitchImage = currentProduct === null || currentProduct === void 0 || (_currentProduct$ticke = currentProduct.ticketPitch) === null || _currentProduct$ticke === void 0 ? void 0 : _currentProduct$ticke.url;
  const ticketPitchImageAvailableWidths = currentProduct === null || currentProduct === void 0 || (_currentProduct$ticke2 = currentProduct.ticketPitch) === null || _currentProduct$ticke2 === void 0 ? void 0 : _currentProduct$ticke2.availableWidths;
  const [shouldPlayAnimation, setShouldPlayAnimation] = React.useState(false);
  function itemClick(selected) {
    var _selected$alternative;
    const productTitle = _.find(products, product => product.type === selected.type);
    document.title = productTitle && productTitle.title || '';
    history.push("/valja/".concat(((_selected$alternative = selected.alternativeUrl) === null || _selected$alternative === void 0 ? void 0 : _selected$alternative.toLowerCase()) || selected.type.toLowerCase()));
  }
  const productInfo = availableTickets.find(ticket => {
    var _ticket$alternativeUr;
    return ((_ticket$alternativeUr = ticket.alternativeUrl) === null || _ticket$alternativeUr === void 0 ? void 0 : _ticket$alternativeUr.toLowerCase()) === ticketType.toLowerCase();
  }) || availableTickets.find(ticket => ticket.type.toLowerCase() === ticketType.toLowerCase());
  useEffect(() => {
    if (!ticketPitchImage || usedPitches.includes(ticketPitchImage)) {
      setTimeout(() => {
        appTimeline.seek('gameReady');
      }, 40);
    }
    usedPitches.push(ticketPitchImage);
  }, [ticketType]);
  if (ticketType && productInfo !== null && productInfo !== void 0 && productInfo.alternativeUrl && productInfo.alternativeUrl.toLowerCase() !== ((_ticketType = ticketType) === null || _ticketType === void 0 ? void 0 : _ticketType.toLowerCase())) {
    const newPath = location.pathname.split('/').slice(2) 
    .join('/').split(ticketType) 
    .join(productInfo.alternativeUrl);
    if (!location.pathname.includes("/".concat(newPath).concat(location.search))) {
      history.replace("/".concat(newPath).concat(location.search));
    }
  }
  function itemPitch() {
    if (ticketPitchImage) {
      setShouldPlayAnimation(!shouldPlayAnimation);
    }
  }
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "padding-top-1 padding-bottom-1 relative games-navigation-wrapper ".concat(menuBg)
  }, React.createElement(ItemsMenu, {
    branding: branding,
    centered: true
  }, products.map(product => {
    var _product$alternativeU2;
    const selected = product.alternativeUrl && ticketType.toLowerCase() === ((_product$alternativeU2 = product.alternativeUrl) === null || _product$alternativeU2 === void 0 ? void 0 : _product$alternativeU2.toLowerCase()) || ticketType.toLowerCase() === product.type.toLowerCase();
    return React.createElement(BallItem, {
      borderOnly: true,
      key: "ball-item-".concat(product.type),
      label: product.name,
      onClick: () => {
        if (selected && pickMatch) {
          itemPitch();
        } else {
          itemClick(product);
        }
      },
      selected: selected
    }, React.createElement(Brand, {
      brand: product.icon,
      className: isTrissBranding ? 'bg-triss-200' : undefined,
      square: !isTrissBranding
    }));
  }))), pickMatch && ticketPitchImage && React.createElement(BubbleUsp, {
    appTimeline: appTimeline,
    isFirstTime: !usedPitches.includes(ticketPitchImage),
    key: ticketType,
    onAnimationEnd: () => {
      setShouldPlayAnimation(false);
    },
    shouldPlayAnimation: shouldPlayAnimation,
    ticketPitchImage: ticketPitchImage,
    ticketPitchImageAvailableWidths: ticketPitchImageAvailableWidths
  }));
};
setGlobal('svs.tickets.play.components.Menu', withRouter(Menu));

 })(window);